import { apiClient } from '../../../lib/api/client';
import { Filters } from '../types';

export const getFilters = () => {
  return apiClient<Filters>({
    url: '/filters',
    method: 'GET',
  });
};
